import React from "react";



const NotFound = () => {

 
  return (
    <>
    <div style={{display: "flex", justifyContent: "center" , alignItems: "center",height: "100vh"}}>
         <img src="./assets/images/zong/404.png"/> 
    </div>
    </>
  );
};

export default NotFound;
